import Image from "../global/Image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import traking from "../../lib/event/tracker";
import styles from "./index.module.css";
import { addLeadingZeros } from "../../lib/utils/priceFormat";
import useElementOnScreen from "../../lib/use/useElementOnScreen";

const ProjectItem = ({
  projet,
  selected = false,
  index,
  onHover = () => {},
  onClick = () => {},
}) => {
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  });
  const [height, setHeight] = useState(0);
  const ref = useRef();
  const ref2 = useRef();

  useEffect(() => {
    if (ref.current) {
      let { height } = ref.current.getBoundingClientRect();
      if (height == 0) {
        let { height: h } = ref2.current.getBoundingClientRect();
        setHeight(h);
      } else {
        setHeight(height);
      }
    }
  }, [ref, ref2, isVisible]);

  const base_link = process.env.NEXT_PUBLIC_HOST_MODE !== "portfolio" ? process.env.NEXT_PUBLIC_LOCATION + "/projet/" : "/projet/";

  return (
    <div
      ref={containerRef}
      onMouseEnter={onHover}
      className={[
        styles.projectItem,
        selected ? styles.selectedProjects : "",
        isVisible ? styles.visibleProject : "",
      ].join(" ")}
    >
      <Link href={base_link + projet.slug}>
        <div
          onClick={(e) => {
            onClick(e);
            traking({
              eventName: `${projet.slug}-open`,
              eventAction: "click",
            });
          }}
        >
          <div className={styles.projectCount}>{addLeadingZeros(index, 2)}</div>
          <div
            className={styles.titles}
            style={{ height, "--h": height + "px" }}
          >
            <h3 ref={ref} className={styles.titleOutline}>
              {projet.name}
            </h3>
            <h3 ref={ref2} className={styles.titleFill}>
              {projet.name}
            </h3>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default ProjectItem;
